module.exports = __webpack_public_path__ + "img/cimage1.42909101.jpg";